import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import Print from 'vue-print-nb'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/normalize.css'
import './assets/global.css'

import './assets/hover-min.css'

import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'

import VueCharts from 'vue-chartjs'

import VueLodash from 'vue-lodash'

import Clipboard from 'v-clipboard'

import noAccess from '@/components/notAccess.vue'

Vue.use(Clipboard)
const options = {
  name: 'lodash'
} 
Vue.use(ElementUI);
Vue.use(VueLodash, options)

Vue.use(VueCharts);
Vue.use(Print);
Vue.use(VueCookies);
Vue.use(VueAxios, axios);
Vue.use(Print);  

Vue.component('noAccess',noAccess);

Vue.config.productionTip = false;

router.afterEach((to, from, next) => {

  window.scrollTo(0, 0);
  store.state.cart_show = true;
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')